import React, { useState } from "react";
import { Button, ModalProps } from "antd";
import CommonModal from "./CommonModal";
import { useAppDispatch } from "../../store/app";
import { useTranslation } from "react-i18next";

interface DeleteModalProps extends ModalProps {
  title?: string;
  close: any;
  deleteValues: any;
  callApi: any;
  name?: string | number;
  keyName?: string | number
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  title,
  close,
  deleteValues,
  callApi,
  keyName
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [saving, setSaving] = useState<boolean>(false);

  const deleteApi = () => {
    setSaving(true);
    callApi(deleteValues.id);
    dispatch(callApi(deleteValues.id))
      .then(() => {
        // if (!data.status) {
        //   form.setFields(data.error);
        // } else {
        close();
        // }
      })
      .catch((error: any) => error)
      .finally(() => setSaving(false));
  };  

  return deleteValues ? (
    <CommonModal
      className="deleteModal"
      title={`${title} ${t("GENERAL.DELETE__DRAWER_TITLE")}`}
      open={deleteValues ? true : false}
      onCancel={close}
      footer={[
        <Button key="2" htmlType="button" className="cancelBtn" onClick={close}>
          {t("GENERAL.CANCEL_BUTTON")}
        </Button>,
        <Button
          key="1"
          htmlType="button"
          type="primary"
          loading={saving}
          onClick={deleteApi}
        >
          {t("GENERAL.DELETE_BUTTON")}
        </Button>,
      ]}
    >
      <div className="deleteNote">
        {t("GENERAL.DELETE_MODEL_MESSAGE")} {deleteValues && <span>{deleteValues[`${keyName}`]}?</span>}
      </div>
    </CommonModal>
  ) : (
    <></>
  );
};
export default DeleteModal;
